import { TServiceClientInitialState, TServiceClientActionTypes } from './types';
import { updateServiceClientState } from './utils';
import {
    DEFAULT_SERVICE_CLIENT_STATE,
    CREATE_SERVICE_CLIENT_VEHICLE,
    GET_SERVICE_CLIENT,
    GET_SERVICE_CLIENTS,
    UPDATE_SERVICE_CLIENT_VEHICLE,
    CREATE_SERVICE_CLIENT,
    UPDATE_SERVICE_CLIENT,
} from './constants';
import { CLEAR_STATE, SET_ERROR, SET_LOADING } from '../types';

export default (
    state: TServiceClientInitialState,
    action: TServiceClientActionTypes
): TServiceClientInitialState => {
    switch (action.type) {
        case CLEAR_STATE:
            return updateServiceClientState(
                state,
                DEFAULT_SERVICE_CLIENT_STATE
            );
        case CREATE_SERVICE_CLIENT_VEHICLE:
        case UPDATE_SERVICE_CLIENT_VEHICLE:
        case CREATE_SERVICE_CLIENT:
        case UPDATE_SERVICE_CLIENT:
        case GET_SERVICE_CLIENT:
            return updateServiceClientState(state, {
                client: action.payload,
                loading: false,
            });

        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case SET_LOADING:
            return updateServiceClientState(state, {
                loading: true,
            });
        case GET_SERVICE_CLIENTS:
            return updateServiceClientState(state, {
                clients: action.payload,
                total: action.total,
            });
        default:
            return state;
    }
};
